/* =============================================================
   merou-torch.js — Torch reveal + random phrase on load

   One phrase shown per page load, picked at random.
   ============================================================= */

(() => {

  // ============================================================
  //  TUNE THESE
  // ============================================================
  const TORCH_RADIUS_DESKTOP = 160;
  const TORCH_RADIUS_MOBILE  = 130;
  const TORCH_EDGE   = 0.45;
  const DARK_ALPHA   = 0.97;
  const DARK_HEIGHT  = 0.70;
  const BG_R = 18; const BG_G = 18; const BG_B = 18;

  const FONT_SIZE_DESKTOP = '14px';
  const FONT_SIZE_MOBILE  = '14px';

  const FADE_DURATION_MS = 1000;

const PHRASES = [
  'Learn every aspect of your craft<br>and substance will follow.<br>— Kobe Bryant',
  'Zoom in and obsess.<br>Zoom out and observe.<br>— Rick Rubin',
  'In a world deluged by irrelevant information,<br>clarity is power.<br>— Yuval Noah Harari',
  'Without a listener,<br>music does not exist.<br>— Susan Rogers',
  'Life is not like water.<br>Things don\'t necessarily flow<br>over the shortest possible route.<br>— Haruki Murakami',
  'All life-forms are in fact<br>processes, not things.<br>— Merlin Sheldrake',
  'The saving of time and the conquest of leisure<br>have no meaning if we are not moved<br>by the laugh of a child at play.<br>— Simone de Beauvoir',
  'Part of the artistic experience<br>is about connecting with something inward<br>that is universal.<br>— Rick Rubin',
];

const lastIndex = parseInt(localStorage.getItem('merouPhraseIndex') ?? '-1');
const randomIndex = (lastIndex + 1) % PHRASES.length;
localStorage.setItem('merouPhraseIndex', randomIndex);

  // ============================================================

  function init() {
    const hero = document.querySelector('[data-merou-sonar]');
    if (!hero) return;

    const hasFine  = window.matchMedia('(pointer: fine)').matches;
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isMobile = hasTouch && !hasFine;
    const TORCH_RADIUS = isMobile ? TORCH_RADIUS_MOBILE : TORCH_RADIUS_DESKTOP;

    // ── Phrase display ─────────────────────────────────
    const wrapper = document.createElement('div');
    wrapper.style.cssText = [
      'position:absolute',
      'top:0',
      'left:0',
      'right:0',
      'height:' + (DARK_HEIGHT * 100) + '%',
      'display:flex',
      isMobile ? 'align-items:flex-start' : 'align-items:center',
      isMobile ? 'padding-top:80%' : '',
      'justify-content:center',
      'pointer-events:none',
      'user-select:none',
      'z-index:1',
    ].join(';');
    hero.appendChild(wrapper);

    const makeSpan = () => {
      const s = document.createElement('p');
      s.style.cssText = [
        isMobile ? 'width:100%' : 'width:33.333%',
        isMobile ? 'padding:0 20px' : 'padding:0 40px',
        'box-sizing:border-box',
        'text-align:center',
        'font-family:inherit',
        'font-size:' + (isMobile ? FONT_SIZE_MOBILE : FONT_SIZE_DESKTOP),
        'line-height:1.5',
        'color:var(--color-foreground,#F6F7F2)',
        'margin:0',
        'position:absolute',
        'transition:opacity ' + FADE_DURATION_MS + 'ms ease',
        'opacity:0',
      ].join(';');
      return s;
    };

    const spanA = makeSpan();
    wrapper.appendChild(spanA);
    wrapper.style.position = 'absolute';

    function showPhrase(index) {
      spanA.innerHTML = PHRASES[index];
      void spanA.offsetHeight;
      spanA.style.opacity = '0.75';
    }

    showPhrase(randomIndex);

    // ── Darkness canvas ────────────────────────────────
    const darkCanvas = document.createElement('canvas');
    darkCanvas.style.cssText = [
      'position:absolute',
      'top:0',
      'left:0',
      'pointer-events:none',
      'z-index:4',
    ].join(';');
    hero.appendChild(darkCanvas);
    const dCtx = darkCanvas.getContext('2d');
    let dW = 0, dH = 0;

    function resizeTorch() {
      const dpr = window.devicePixelRatio || 1;
      const r   = hero.getBoundingClientRect();
      dW = r.width;
      dH = r.height * DARK_HEIGHT;
      darkCanvas.width        = Math.round(dW * dpr);
      darkCanvas.height       = Math.round(dH * dpr);
      darkCanvas.style.width  = dW + 'px';
      darkCanvas.style.height = dH + 'px';
      dCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
      drawTorch(-9999, -9999);
    }

    function drawTorch(lx, ly) {
      dCtx.clearRect(0, 0, dW, dH);
      dCtx.fillStyle = `rgba(${BG_R},${BG_G},${BG_B},${DARK_ALPHA})`;
      dCtx.fillRect(0, 0, dW, dH);
      dCtx.save();
      dCtx.globalCompositeOperation = 'destination-out';
      const g = dCtx.createRadialGradient(lx, ly, 0, lx, ly, TORCH_RADIUS);
      g.addColorStop(0,              `rgba(0,0,0,${DARK_ALPHA})`);
      g.addColorStop(1 - TORCH_EDGE, `rgba(0,0,0,${DARK_ALPHA})`);
      g.addColorStop(1,               'rgba(0,0,0,0)');
      dCtx.fillStyle = g;
      dCtx.beginPath();
      dCtx.arc(lx, ly, TORCH_RADIUS, 0, Math.PI * 2);
      dCtx.fill();
      dCtx.restore();
    }

    requestAnimationFrame(resizeTorch);
    window.addEventListener('resize', resizeTorch);

    // ── Animation loops ────────────────────────────────
    if (!isMobile) {
      (function tick() {
        requestAnimationFrame(tick);
        const pos = window.__merouCursor;
        if (!pos || pos.subX < -900) return;
        const rect = hero.getBoundingClientRect();
        const lx = pos.subX - rect.left;
        const ly = pos.subY - rect.top;
        drawTorch(lx, ly);
      })();
    } else {
      (function tick() {
        requestAnimationFrame(tick);
        const pos = window.__merouSonar;
        if (!pos) return;
        drawTorch(pos.subX, pos.subY);
      })();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();